//@ts-nocheck
import React from "react";
import { Box } from "@chakra-ui/react";

export default function Section({ children, ...props }) {
  return (
    <Box width={"100%"} {...props}>
      {children}
    </Box>
  );
}
